import { useEffect, useRef, useState } from 'react';
import { throttle } from 'underscore';

const getResult = (plainValue: number, checkFunc?: () => number) => {
    const value = checkFunc ? checkFunc() : plainValue;
    const scrollValue = parseInt(document.getElementsByTagName('html')[0].style.top) || window.scrollY;

    return Math.abs(scrollValue) > value;
};

type TScrollSpyProps = {
    value: number;
    checkFunc?: () => number;
    handlerAfterChange?: (isScrollSpy: boolean) => void;
}

export const useScrollSpy = ({
    value,
    checkFunc,
    handlerAfterChange
}: TScrollSpyProps) => {
    const [isScrollSpy, setIsScrollSpy] = useState(getResult(value, checkFunc));
    const isMounted = useRef(true);

    const throttledGetResult = throttle(() => {
        if (!isMounted.current) {
            return;
        }

        setIsScrollSpy(getResult(value, checkFunc));
    }, 100, { leading: false });

    useEffect(() => {
        if (!handlerAfterChange) {
            return;
        }

        handlerAfterChange(isScrollSpy);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isScrollSpy]);

    useEffect(() => {
        window.addEventListener('scroll', throttledGetResult);

        throttledGetResult();

        return () => {
            isMounted.current = false;
            window.removeEventListener('scroll', throttledGetResult);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        isScrollSpy,
        refreshScrollSpy: throttledGetResult
    };
};
